import { useEffect } from "react";
import { clearNotice, useNotice } from "@/lib/notice";
import { Icon } from "./icons";

/** Onde o aviso de sucesso aparece (canto da tela; lido por leitor de tela). */
export function NoticeArea() {
  const notice = useNotice();
  useEffect(() => {
    if (!notice) return;
    const timer = setTimeout(() => clearNotice(notice.id), 5000);
    return () => clearTimeout(timer);
  }, [notice]);
  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-4 bottom-4 z-50 flex justify-end sm:inset-x-auto sm:right-4"
    >
      {notice && (
        <div className="pointer-events-auto flex max-w-md items-start gap-3 rounded-xl border border-success/30 bg-card px-4 py-3 text-sm shadow-pop">
          <span className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full bg-success-soft text-success">
            <Icon name="check" size={14} strokeWidth={3} />
          </span>
          <span className="pt-0.5 leading-relaxed">{notice.message}</span>
          <button
            type="button"
            className="ml-auto flex size-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted"
            aria-label="Fechar aviso"
            onClick={() => clearNotice(notice.id)}
          >
            <Icon name="close" size={16} strokeWidth={2} />
          </button>
        </div>
      )}
    </div>
  );
}
